// extracted by mini-css-extract-plugin
export default {"rightCOntainer":"LoginAVolunteer_rightCOntainer__dT90z"};